import { FormValidationFunction } from '@/views/interfaces/vuetify/form.interface';

export default class XDNFeaturesForm {
  public captcha: boolean = false;
  public captchaLevel: boolean = false;
  public qsIgnore: boolean = false;
  public cacheReferer: string[] = [];
  public cacheBypass: boolean = false;
  public uaList: string[] = [];
  public countryBan: string[] = [];
  public countryAction: 'allow' | 'ban' | '' = '';
  public countryHtAccess: boolean = true;

  public rules: { [name: string]: FormValidationFunction[] } = {
    cacheReferer: [
      (v: string[]) => !v.length || v.every((v) => /^(?!:\/\/)([a-zA-Z0-9]([a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?\.)+[a-zA-Z]{2,}$/.test(v)) || 'Invalid Cache Referer',
    ],
    countryAction: [(v: string) => !v.length || ['', 'allow', 'ban'].includes(v) || 'Invalid Country Action'],
  };
}

export const countryActions: { text: string, value: string }[] = [
  { text: 'NO ACTION', value: '' },
  { text: 'ALLOW', value: 'allow' },
  { text: 'BAN', value: 'ban' },
];

export const userAgents: string[] = [
  'ahrefsbot',
  'apache-httpclient',
  'blexbot',
  'bot',
  'chrome',
  'claudebot',
  'cliqzbot',
  'dataforseobot',
  'debugbear',
  'edg',
  'electron',
  'ezautoinsert',
  'facebookexternalhit',
  'fidget-spinner-bot',
  'firefox',
  'go-http-client',
  'gptbot',
  'gtmetrix',
  'hotjar',
  'linguee',
  'bot',
  'linkedinbot',
  'make/production',
  'mauibot',
  'mj12bot',
  'mozlila',
  'msie',
  'my-tiny-bot',
  'nitro',
  'nutch',
  'pingdom',
  'preload',
  'python-requests',
  'restsharp',
  'rogerbot',
  'safari',
  'scrapy',
  'seekport',
  'site.ru',
  'test-bot',
  'the',
  'incutio',
  'xml-rpc',
  'php',
  'library',
  'thesis-research-bot',
  'tinytestbot',
  'trident',
  'wp-compress',
  'x-middleton',
  'curl',
  'wget',
];
